// extracted by mini-css-extract-plugin
export default {"app-loader":"App_app-loader__nE-6I"};